import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./sdk.css";
import Python from "../../../../../assets/images/python.png";
import Cplus from "../../../../../assets/images/cplus.png";
import Csharp from "../../../../../assets/images/csharp.png";
import Dotnet from "../../../../../assets/images/dotnet.png";
import Json from "../../../../../assets/images/json.png";
import Swift from "../../../../../assets/images/swift.png";
import Nodejs from "../../../../../assets/images/nodejs.png";
import Angular from "../../../../../assets/images/angular.png";
import Kotlin from "../../../../../assets/images/kotlin.png";
import Reactjs from "../../../../../assets/images/reactjs.png";
import Postman from "../../../../../assets/images/postman.png";
import { useDispatch, useSelector } from "react-redux";
import { RequestGitHubAccess } from "api-services";
import { CircularProgress, Modal } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import products from "static-data/products";

function Sdk() {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [emailAddress, setEmailAddress] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [failed, setFailed] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState("");
  const [buttonName, setButtonName] = useState("");
  let filteredProducts = [];
  let newProducts = [];
  const userData = useSelector((state) => state.authentication?.user_data);

  const { loading } = useSelector((state) => state.authentication);
  const dispatch = useDispatch();

  if (userData?.customer?.roleId == 1) {
    filteredProducts = products.filter((prod) =>
      userData.apirequestaccessItem.find(
        (item) => item.apiid == prod.key && item.status == "A"
      )
    );
    newProducts = products.filter(
      (prod) => !filteredProducts.find((item) => item.key == prod.key)
    );
  }
  useEffect(() => {
    if (userData.customer) {
      setEmailAddress(userData?.customer?.email);
    }
  }, []);

  const handleSubmit = () => {
    setError("");
    setSuccess(false);
    setFailed(false);

    if (emailAddress == "") {
      setError("Email Address cannot be empty");
    } else {
      RequestGitHubAccess(
        dispatch,
        { repositoryName: buttonName, email: emailAddress },
        () => {
          setSuccess(true);
          setTimeout(() => {
            handleClose();
            setError(false);
            setSuccess(false);
            setFailed(false);
          }, 2000);
        },
        setShowErrorMessage,
        clearFields
      );
    }
  };
  const clearFields = () => {
    setEmailAddress("");
  };

  return (
    <>
      <div className="wrap-sdk">
        <div className="container">
          <div className="row">
            <div className="col-md-6 mb-5">
              <h4 className="sdk-title">Client SDKs</h4>
              <p className="sdk-desc pe-5">
                VCT Technologies provides native SDKs in C++, C#/.NET, and
                Python. Leverage these libraries to easily access our API in
                your own application code or your trading scripts natively. Do
                you code in another language? We've got you covered too!{" "}
                <Link
                  className="follow-link"
                  to={
                    userData?.customer
                      ? "/dashboard"
                      : "/authentication/sign-up"
                  }
                >
                  Follow this link
                </Link>
                to get access to the Postman collection for our JSON based APIs
                and interact with our system in your preferred language using
                simple RESTful API operations.
              </p>
              {userData?.customer ? (
                ""
              ) : (
                <Link
                  className="sdk-link"
                  to={"/authentication/sign-up"}
                  onClick={() => {
                    if (userData?.customer) {
                      setButtonName("Account Opening API");
                      handleOpen();
                    }
                  }}
                >
                  Account Opening API
                </Link>
              )}
              {userData?.customer ? (
                ""
              ) : (
                <Link
                  className="sdk-link"
                  to={"/authentication/sign-up"}
                  onClick={() => {
                    if (userData?.customer) {
                      setButtonName("Funding API");
                      handleOpen();
                    }
                  }}
                >
                  Funding API
                </Link>
              )}
              {userData?.customer ? (
                ""
              ) : (
                <Link
                  className="sdk-link"
                  to={"/authentication/sign-up"}
                  onClick={() => {
                    if (userData?.customer) {
                      setButtonName("Trading API");
                      handleOpen();
                    }
                  }}
                >
                  Trading API
                </Link>
              )}

              {filteredProducts.map(({ name, link }) => {
                const handleURLRecirect = (url) => {
                  window.open(url, "_blank", "noopener,noreferrer");
                };

                return (
                  <button
                    key={name}
                    className="sdk-link"
                    onClick={() => handleURLRecirect(link)}
                  >
                    {name != "FIX Specifications" ? name : ""}
                  </button>
                );
              })}
              {newProducts.map(({ name }) => {
                return (
                  <Link
                    key={name}
                    className="sdk-link"
                    to="#"
                    onClick={() => {
                      if (userData?.customer) {
                        setButtonName(name);
                        handleOpen();
                      }
                    }}
                  >
                    {name != "FIX Specifications" ? name : ""}
                  </Link>
                );
              })}
            </div>
            <div className="col-md-6 mb-5">
              <div className="row">
                <div className="col-6 col-md-4 text-center mb-4">
                  <img src={Python} alt="Python" title="Python" />
                </div>
                <div className="col-6 col-md-4 text-center mb-4">
                  <img src={Cplus} alt="C++" title="C++" />
                </div>
                <div className="col-6 col-md-4 text-center mb-4">
                  <img src={Csharp} alt="C#" title="C#" />
                </div>
                <div className="col-6 col-md-4 text-center mb-4">
                  <img src={Dotnet} alt=".Net" title=".Net" />
                </div>
                <div className="col-6 col-md-4 text-center mb-4">
                  <img src={Json} alt="JSON" title="JSON" />
                </div>
              </div>
            </div>

            <div className="col-md-6 mt-5 d-block d-md-none">
              <h4 className="sdk-title ps-5">Simple JSON Samples</h4>
              <p className="sdk-desc ps-5">
                In addition to the native SDKs directly supported by VCT
                Technologies, our team has leveraged the simplicity of JSON to
                write simple trading scripts in various different languages.{" "}
              </p>
            </div>
            <div className="col-md-6 mt-5 d-block d-md-none">
              <div className="row">
                <div className="col-6 col-md-4 text-center mb-4">
                  <img src={Swift} alt="Swift" title="Swift" />
                </div>
                <div className="col-6 col-md-4 text-center mb-4">
                  <img src={Nodejs} alt="NodeJS" title="Node JS" />
                </div>
                <div className="col-6 col-md-4 text-center mb-4">
                  <img src={Angular} alt="Angular" title="Angular" />
                </div>
                <div className="col-6 col-md-4 text-center mb-4">
                  <img src={Kotlin} alt="Kotlin" title="Kotlin" />
                </div>
                <div className="col-6 col-md-4 text-center mb-4">
                  <img src={Reactjs} alt="ReactJS" title="React JS" />
                </div>
                <div className="col-6 col-md-4 text-center mb-4">
                  <img src={Postman} alt="Postman" title="Postman" />
                </div>
              </div>
            </div>

            <div className="col-md-6 mt-5 d-none d-md-block">
              <div className="row">
                <div className="col-md-4 text-center mb-4">
                  <img src={Swift} alt="Swift" title="Swift" />
                </div>
                <div className="col-md-4 text-center mb-4">
                  <img src={Nodejs} alt="NodeJS" title="Node JS" />
                </div>
                <div className="col-md-4 text-center mb-4">
                  <img src={Angular} alt="Angular" title="Angular" />
                </div>
              </div>
              <div className="row">
                <div className="col-md-4 text-center mb-4">
                  <img src={Kotlin} alt="Kotlin" title="Kotlin" />
                </div>
                <div className="col-md-4 text-center mb-4">
                  <img src={Reactjs} alt="ReactJS" title="React JS" />
                </div>
                <div className="col-md-4 text-center mb-4">
                  <img src={Postman} alt="Postman" title="Postman" />
                </div>
              </div>
            </div>
            <div className="col-md-6 mt-5 d-none d-md-block">
              <h4 className="sdk-title ps-5">Simple JSON Samples</h4>
              <p className="sdk-desc ps-5">
                In addition to the native SDKs directly supported by{" "}
                <span>VCT Technologies</span>, our team has leveraged the
                simplicity of JSON to write simple trading scripts in various
                different languages.{" "}
              </p>
            </div>
          </div>
        </div>
      </div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <MDBox sx={style}>
          <MDBox onClick={handleClose} className="close-modal-sm">
            <CloseRoundedIcon />
          </MDBox>
          {/* <MDInput type="email" label="Email Address" color="success" variant="outlined" value={emailAddress} onChange={(e) => setEmailAddress(e.target.value)} fullWidth className="inputbox mb-2" required /> */}

          {success && (
            <MDTypography color="success" variant="subtitle2">
              Request submitted successfully!
            </MDTypography>
          )}
          {showErrorMessage != "" ? (
            <MDTypography color="error" variant="subtitle2">
              {showErrorMessage}
            </MDTypography>
          ) : (
            failed && (
              <MDTypography color="error" variant="subtitle2">
                There was an error submitted the request
              </MDTypography>
            )
          )}
          {error && (
            <MDTypography
              color="error"
              variant="subtitle2"
              sx={{ fontSize: "12px" }}
            >
              {error}
            </MDTypography>
          )}
          <MDButton
            className="btn-update mt-2 px-2 py-3"
            sx={{ paddingLeft: 6.5, paddingRight: 6.5 }}
            variant="gradient"
            color="success"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              `Request ${buttonName} GitHub Access`
            )}
          </MDButton>
        </MDBox>
      </Modal>
    </>
  );
}
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "20%",
  bgcolor: "#000",
  borderRadius: 2,
  border: 1,
  borderColor: "grey.700",
  boxShadow: 100,
  p: 0,
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  padding: 5,
};

export default Sdk;
